'use strict';

var util = require('../util/property-util');
var FileSaver = require('file-saver');

module.exports = /*@ngInject*/ ["$filter", "LocaleFactory", function CsvFactory($filter, LocaleFactory) {
    var factory = {};
    /**
     * This function will generate a csv formatted string for the provided data
     *
     * @param dataArray         an array of json objects
     * @param propertiesList    an array of objects
     *                          {   property: propertyname,     required: this is the actual propertyname that is specified in the data objects
     *                              formatFunction: function,   optional: this function will be called when parsing to csv (for data under this property)
     *                              displayName: display name}  optional: this value will be used as a the header in csv
     * @param headers           boolean: if true the function will generate headers
     * @param seperator         string: this string will be used to seperate the values (defaults to ;)
     * @returns {string}        returns the csv as a large string
     */
    factory.createCSV = function (dataArray, propertiesList, headers, seperator) {
        var csvString = "";
        seperator = util.isDefined(seperator) ? seperator : ";";
        if (headers) {
            csvString += factory.generateHeaders(propertiesList, seperator);
        }
        dataArray.forEach(function (jsonObject) {
            csvString += parseLine(jsonObject, propertiesList, seperator);
            csvString += "\n";
        });
        return csvString;
    };
    /**
     * Generates headers for a csv, seperated with the specified seperator
     * @param propertiesList    (see createCSV function)
     * @param seperator         string: this string will be used to seperate the values (defaults to ;)
     * @returns {string}
     */
    factory.generateHeaders = function (propertiesList, seperator) {
        var csvHeader = "";
        propertiesList.forEach(function (propertiesObject) {
            csvHeader += util.isDefined(propertiesObject.displayName) ? propertiesObject.displayName : propertiesObject.property;
            csvHeader += seperator;
        });
        csvHeader += "\n";
        return csvHeader;
    };

    /**
     * Returns a list of propertyobjects (see createCSV function) for a given json object
     * @param jsonObject
     * @returns {Array}
     */
    factory.getPropertyNamesFromJsonObject = function (jsonObject) {
        var list = [];
        for (var property in jsonObject) {
            if (jsonObject.hasOwnProperty(property)) {
                list.push({
                    property: property,
                    formatFunction: function (value) {
                        return value;
                    }
                });
            }
        }
        return list;
    };
    /**
     * Download the csvString as file to the client
     * @param csv       the csvString (or any string)
     * @param filename  filename to be used
     */
    factory.download = function (csv, filename) {
        var blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
        if (!util.isDefined(filename)) {
            filename = $filter('tzdate')(new Date(), 'YYYY/MM/DD HH:mm') + ".csv";
        }
        FileSaver.saveAs(blob, filename);

    };

    var parseLine = function (jsonObject, propertyObjects, seperator) {
        var csvLine = "";
        propertyObjects.forEach(function (propertyObject) {
            var propertyName = propertyObject.property;
            if (jsonObject.hasOwnProperty(propertyName)) {
                if (util.isDefined(propertyObject.formatFunction)) {
                    csvLine += LocaleFactory.formatCSVValue(propertyObject.formatFunction(jsonObject[propertyName]));
                } else {
                    csvLine += LocaleFactory.formatCSVValue(jsonObject[propertyName])
                }
            }
            csvLine += seperator;
        });
        return csvLine;
    };

    return factory;

}];